<ion-grid class="ion-no-padding" *ngIf="!deviceOrientationChanged">
  <ion-row class="ion-no-padding">
    <ion-col
      *ngFor="let view of views; trackBy: trackByFn"
      class="ion-no-padding auto-flex-basis"
      [ngStyle]="{ width: view.width }"
    >
      <smr-day-view-calendar
        [config]="view"
        (onEventSelected)="eventSelectedHandler($event)"
        (onTimeSelected)="onTimeSelectedHandler($event)"
        (onEventDragEnd)="onEventDragEndHandler($event)"
      >
      </smr-day-view-calendar>
    </ion-col>
  </ion-row>
</ion-grid>

<!-- <ion-slides
  *ngIf="isMobile"
  [options]="slideOpts"
  (ionSlideNextEnd)="loadNext()"
  (ionSlidePrevEnd)="loadPrev()"
>
  <ion-slide *ngFor="let views of viewsList">
    <ion-grid class="ion-no-padding" *ngIf="!deviceOrientationChanged">
      <ion-row class="ion-no-padding">
        <ion-col
          *ngFor="let view of views; trackBy: trackByFn"
          class="ion-no-padding auto-flex-basis"
          [ngStyle]="{ width: view.width }"
        >
          <smr-day-view-calendar
            [config]="view"
            (onEventSelected)="eventSelectedHandler($event)"
            (onTimeSelected)="onTimeSelectedHandler($event)"
            (onEventDragEnd)="onEventDragEndHandler($event)"
          >
          </smr-day-view-calendar>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-slide>
</ion-slides> -->
